

























import { Vue, Component, Prop } from 'vue-property-decorator';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';

@Component({
  components: {
    ScrollbarWrapper,
  },
})
export default class Modal extends Vue {
  @Prop(Boolean) readonly value!: boolean;
  @Prop({ default: 'default' }) readonly variant!: string;
  @Prop({ default: 'full' }) readonly size!: string;
  @Prop({ default: 'modal' }) readonly target!: string;
  @Prop({ default: false }) readonly withHeader!: boolean;
  @Prop({ default: '' }) headerColor!: string;

  get inputVal() {
    return this.value;
  }

  set inputVal(val) {
    this.$emit('input', val);
  }
}
